import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { AuthenticationService } from './authentication.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  constructor(private authService: AuthenticationService) { }

  canActivate(): boolean {
    var flag: boolean = false;
   // if (this.authService.isAdmin())
   if (this.authService.isAdmin() || this.authService.isDeveloper() || this.authService.isDongleProvider() || this.authService.isFinanceAdmin())
      flag = true;

    return flag;
  }
}
